module.exports = __webpack_public_path__ + "static/media/consumer-power-tablet.472c0020.jpg";